<template lang="html">
    <div class="cover-popup row-center" v-if="show">
        <div class="popup">
            <p>
                <strong>Como usuario de esta plataforma UPM desea enviarle comunicaciones  relacionadas con propuestas y  procesos de selección para tramitar con usted.  Por favor, marque a continuación para aceptar el envío de estas comunicaciones:</strong>
            </p>
            <div class="contenedor-input three-slot mb-0">
                <input type="checkbox" name="comunicaciones" id="comunicaciones"
                    v-model="aceptaRecibirInformacionUniversidad" />
                <label for="comunicaciones">
                    He leído la <a :href="server+'/recursosCliente/UPM/Documentos/POLITICA_PRIVACIDAD_UPM.pdf'" target="_blank" rel="noopener noreferrer">Política de protección de datos personales</a> y acepto recibir comunicaciones.
                </label>
            </div>
            <div class="contenedor-boton">
                <button class="btn -solid-primary" @click="aceptarComunicaciones">
                    {{ $t("guardar") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="js">
import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'popup-aceptar-comunicaciones-empresa',
    data() {
        return {
            aceptaRecibirInformacionUniversidad: false
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        ...mapActions(['sendRecibirInfoUniversidadEmpresa']),
        aceptarComunicaciones() {
            window.localStorage.setItem("faltaDatoDeseaRecibirInformacionUni",  false);
            this.sendRecibirInfoUniversidadEmpresa(
            {
              'aceptaRecibirInformacionUniversidad': this.aceptaRecibirInformacionUniversidad
            })
            this.$emit('guardar');
        }
    },
    computed: {
        ...mapGetters({
            server: 'getServer'
        })
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/colors.scss";

.cover-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}

.popup {
    background: white;
    padding: 30px;
    max-width: 800px;
    width: 90%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);

    p {
        margin-bottom: 5px;
        line-height: 1.5;
        color: $dark-black;

        strong {
            font-weight: 600;
        }
    }
}

.contenedor-boton {
    display: flex;
    gap: 15px;
    justify-content: center;

}

@media screen and (max-width: 520px) {
    .popup {
        padding: 20px;
        margin: 20px;
    }

    .contenedor-boton {
        flex-direction: column;

        .btn {
            width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/popup-aceptar-comunicaciones-empresa.vue